const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDeepmind(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1024 351",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "deepmind-logo",
    transform: "matrix(0.374963,0,0,0.374963,513.629,175.369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-866.6,-271.5C-904.1,-289.2 -948.7,-300 -991.1,-300C-1119,-300 -1195.5,-194.1 -1187.3,-90.7C-1183.6,-43.9 -1160.6,1.4 -1122.6,36.8C-1109,49.6 -1093.8,60.5 -1077.3,69.3C-1089.7,54.5 -1097.9,36.6 -1101.1,17.5C-1109.6,-34.5 -1075.3,-111 -987.6,-111C-893.3,-111 -789.4,-21.3 -780.7,88.9C-775.3,156.4 -800.9,217.1 -844.1,259.5C-754.6,207.6 -694.5,110.9 -694.5,0C-694.5,-119.9 -764.9,-223.4 -866.6,-271.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-801.7,90.7C-805.4,43.9 -828.4,-1.4 -866.4,-36.8C-880,-49.6 -895.2,-60.5 -911.7,-69.3C-899.3,-54.5 -891.1,-36.6 -887.9,-17.5C-879.4,34.5 -913.7,111 -1001.4,111C-1095.7,111 -1199.6,21.3 -1208.3,-88.9C-1213.7,-156.3 -1188.1,-217.1 -1144.9,-259.5C-1234.3,-207.6 -1294.4,-110.8 -1294.4,0.1C-1294.4,120 -1224,223.5 -1122.3,271.6C-1084.8,289.3 -1040.2,300.1 -997.8,300.1C-870,300 -793.5,194.1 -801.7,90.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-448.7,-150L-544.3,-150L-544.3,150L-448.7,150C-343.3,150 -294.8,92.6 -294.8,0.4C-294.8,-92.1 -343.3,-150 -448.7,-150ZM-450,114L-501.9,114L-501.9,-114.4L-450.1,-114.4C-367,-114.4 -338.2,-70.7 -338.2,0.5C-338.1,71.1 -366.8,114 -450,114Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-168.2,-67.7C-231.6,-67.7 -274.9,-22.7 -274.9,44.6C-274.9,111 -231.2,155.2 -168.6,155.2C-118.4,155.2 -83.7,125.2 -72.2,85.3L-114.6,85.3C-123.2,106.3 -142,120 -168.6,120C-201.6,120 -230.7,96.9 -233.3,53.6L-66.6,53.6C-66.2,45.9 -66.2,39.5 -66.2,33.5C-66.2,-21.4 -105.7,-67.7 -168.2,-67.7ZM-232.5,23.6C-227.8,-13.3 -200.4,-32.5 -168.7,-32.5C-135.3,-32.5 -110,-11.1 -108.3,23.6L-232.5,23.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8,-67.7C-0.6,-67.7 -43.9,-22.7 -43.9,44.6C-43.9,111 -0.2,155.2 62.4,155.2C112.5,155.2 147.2,125.2 158.8,85.3L116.4,85.3C107.8,106.3 89,120 62.4,120C29.4,120 0.3,96.9 -2.3,53.6L164.4,53.6C164.8,45.9 164.8,39.5 164.8,33.5C164.8,-21.4 125.3,-67.7 62.8,-67.7ZM-1.5,23.6C3.2,-13.3 30.6,-32.5 62.4,-32.5C95.8,-32.5 121.1,-11.1 122.8,23.6L-1.5,23.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.9,-67.7C269.8,-67.7 245.8,-49.3 232.5,-28.7L228.2,-62.6L190,-62.6L190,244.2L232.5,244.2L232.5,116.6C247.1,141 273.6,155.2 307.5,155.2C370.1,155.2 412.9,108.5 412.9,44.2C412.9,-20.1 370,-67.7 307.9,-67.7ZM301,118.3C261.1,118.3 232.4,88.3 232.4,43.7C232.4,-0.4 261.1,-30.9 301,-30.9C341.3,-30.9 369.6,-0.5 369.6,43.7C369.6,88.3 341.3,118.3 301,118.3Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.6,52.7L486.9,-150L437.2,-150L437.2,150L479.6,150L479.6,-75.9L574.3,107.1L606.9,107.1L701.2,-75.9L701.2,150L743.6,150L743.6,-150L693.9,-150L590.6,52.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.6,
    y: -62.6,
    width: 42.4,
    height: 212.6,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.6,-158.6C781.7,-158.6 769.7,-147.5 769.7,-132C769.7,-116.5 781.7,-105 797.6,-105C813.9,-105 825.9,-116.6 825.9,-132C825.9,-147.4 813.9,-158.6 797.6,-158.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966,-67.7C933,-67.7 906.4,-51.4 892.7,-25.3L889.7,-62.6L852,-62.6L852,150L894.5,150L894.5,40.3C894.5,-6 919.8,-31.3 954.5,-31.3C988.8,-31.3 1006.4,-10.3 1006.4,31.7L1006.4,150L1048.4,150L1048.4,27.4C1048.3,-36.4 1017,-67.7 966,-67.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.1,-159.5L1252.1,-30.1C1237.5,-54.5 1211,-68.7 1176.7,-68.7C1114.1,-68.7 1071.7,-22 1071.7,42.3C1071.7,106.6 1114.1,154.2 1176.3,154.2C1214.4,154.2 1238.4,135.8 1252.2,115.2L1256.5,149.1L1294.6,149.1L1294.6,-159.5L1252.1,-159.5ZM1183.1,117.3C1143.2,117.3 1114.5,86.9 1114.5,42.7C1114.5,-1.9 1143.2,-31.9 1183.1,-31.9C1223.4,-31.9 1251.7,-1.9 1251.7,42.7C1251.6,86.9 1223.4,117.3 1183.1,117.3Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDeepmind);
export default __webpack_public_path__ + "static/media/logo-deepmind.f10789c6b20d67de3930d14d5649322d.svg";
export { ForwardRef as ReactComponent };